import { ExportFramework } from "@pages/Templates/constants";

/**
 * `unified_export` only carries a meaningful per-template value for
 * DOCXTEMPLATER. HANDLEBARS always renders through the unified server-side
 * pipeline (so it's always true) and GOOGLE_DOCS never consults it (always
 * false). Use this when the export framework changes so the edit-state stays in
 * lockstep with the framework — matching the backend coercion in
 * ReportTemplate.save (PROA-2237).
 *
 * `savedUnifiedExport` should be the persisted value only when the template was
 * already DOCXTEMPLATER; a template arriving from another framework has no
 * migrated .docx yet and must not silently start checked.
 */
export const resolveUnifiedExport = (framework: string, savedUnifiedExport: boolean): boolean => {
  switch (framework) {
    case ExportFramework.HANDLEBARS:
      return true;
    case ExportFramework.DOCXTEMPLATER:
      return savedUnifiedExport;
    default:
      return false;
  }
};
